/**
 * MUI components that set their own pixel font size instead of reading the
 * theme's typography (checked in MUI's source): ToggleButton 13px small /
 * 15px large, TablePagination 14px, Chip 13px, Tooltip 14px on touch screens,
 * Badge 12px. Each is pointed at the app's type scale (`--fs-*` in
 * tokens.css) so every screen uses the same five sizes and one font.
 */
import type { Components, Theme } from '@mui/material/styles';

const sans = 'var(--font-sans)';

/* The filter chips ("All 11 · Preparing 2 …") and the view switches
   (Result / Exceptions, Report 1 / 2): body size, like the table under them. */
export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
	styleOverrides: {
		root: { fontFamily: sans, fontSize: 'var(--fs-body)', fontWeight: 500 },
		sizeSmall: { fontSize: 'var(--fs-body)' },
		sizeLarge: { fontSize: 'var(--fs-body)' },
	},
};

/* "Rows per page 100 · Rows 1–6 of 6" above every table. */
export const MuiTablePagination: Components<Theme>['MuiTablePagination'] = {
	styleOverrides: {
		root: { fontFamily: sans, fontSize: 'var(--fs-body)' },
		selectLabel: { fontSize: 'var(--fs-body)' },
		displayedRows: { fontSize: 'var(--fs-body)' },
		input: { fontSize: 'var(--fs-body)' },
	},
};

export const MuiChip: Components<Theme>['MuiChip'] = {
	styleOverrides: {
		root: { fontFamily: sans, fontSize: 'var(--fs-small)' },
	},
};

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
	styleOverrides: {
		tooltip: { fontFamily: sans, fontSize: 'var(--fs-small)' },
		/* MUI makes a tooltip 14px on touch screens; keep it on the scale. */
		touch: { fontSize: 'var(--fs-small)' },
	},
};

export const MuiBadge: Components<Theme>['MuiBadge'] = {
	styleOverrides: {
		badge: { fontFamily: sans, fontSize: 'var(--fs-small)' },
	},
};
